module.exports = __webpack_public_path__ + "img/yunpt.a53fb358.png";